import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { RewardBanner } from './rewardBanner';

// The merchant's reward banner, full width at its own aspect ratio. An image that fails to
// load hides the banner instead of showing a broken image.
const RewardBannerImage: React.FC<{ banner: RewardBanner | null }> = ({ banner }) => {
  const { t } = useTranslation();
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  if (!banner || banner.imageUrl === failedUrl) return null;
  return (
    <img
      src={banner.imageUrl}
      alt={t('dashboard.rewards.bannerAlt')}
      className="block w-full h-auto rounded-[10px] mb-6"
      onError={() => setFailedUrl(banner.imageUrl)}
    />
  );
};

export default RewardBannerImage;
